import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import React from 'react';

import { TmOrderHistoryDetail } from '@/tscapi/model/order';
import http from '@/tscapi/service/httpservice';
import { Cookie } from '@/tscapi/utils/cookie';

export function useOrder(isAuth: boolean, modifyOrderNumber) {
    const cookie: Cookie = new Cookie();
    return useQuery({
        queryKey: ['order', modifyOrderNumber, cookie.CartGuid, cookie.UserAccessToken?.Edp],
        queryFn: () => fetchOrder(modifyOrderNumber),
        enabled: !!modifyOrderNumber && modifyOrderNumber.length > 0,
        useErrorBoundary: false,
        retry: false,
    });

    async function fetchOrder(modifyOrderNumber): Promise<TmOrderHistoryDetail> {
        const headers = {
            'Content-Type': 'application/json',
            'cache-control': 'no-cache',
            currentdatetime: cookie.CurrentDate,
        };
        const base = '/api/v2/';
        const lang = cookie.Language.substring(0, 2) || 'en';
        const userAccessTokenEdp = cookie.UserAccessToken?.Edp;
        try {
            const response = await http.get(
                `${base}${lang}/accounts/${userAccessTokenEdp}/orders/${modifyOrderNumber}?validate=false`,
                {
                    headers: headers,
                },
            );
            setupAnalyticsData(response.data);
            return response.data as TmOrderHistoryDetail;
        } catch (error) {
            //if this state happens, user will be re-directed to signin page anyway
            console.log('Error getting Order');
            throw new Error('Error getting Order');
        }
    }
}
const setupAnalyticsData = (cart) => {
    //window.analyticsData.cart = cart; // cart contain details send by the API call
};
